// Shared date-range helpers + quick-select presets for the admin scoreboard and history.

export function todayStr() {
    const d = new Date();
    const p = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function yesterdayStr() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const p = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// startOfWeek is Monday of the current week (Danish weeks start on Monday).
export function startOfWeek() {
    const d = new Date();
    d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
    const p = n => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function startOfMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
}

export function startOfYear() {
    return `${new Date().getFullYear()}-01-01`;
}

// Riddlehouse predates none of this — an early anchor stands in for "all time".
export const ALL_TIME_FROM = "2015-01-01";

export const RANGE_PRESETS = [
    { key: "week", label: "Denne uge", from: startOfWeek },
    { key: "month", label: "Denne måned", from: startOfMonth },
    { key: "year", label: "I år", from: startOfYear },
    { key: "all", label: "Altid", from: () => ALL_TIME_FROM },
];

// activePresetKey returns the key of the preset matching the current range (start matches
// and it ends today), or undefined for a custom range.
export function activePresetKey(from, to) {
    return RANGE_PRESETS.find(p => p.from() === from && to === todayStr())?.key;
}
